import React, { useContext, useState, useEffect } from 'react';
import useSectionStyles from './styles';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';
import PageContext from '../../contexts/pageContext';
import { postApiCall } from '../../utils/services';
import Button from '../../components/button';
import Input from '../../components/input';
export default function FormEnquiry({ sectionData }) {
  const {
    layout: { containerWidth },
    baseURLs,
    isMobile,
    validations,
    isPreview,
    isEdit,
    isLandingPages,
    extraProps
  } = useContext(PageContext);
  const classes = useSectionStyles({ containerWidth, isMobile });
  const [nodeData] = sectionData.components;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const theme = useTheme();

  let [btnDisabled, setBtnDisabled] = useState(false);

  let formInitialValue = {
    name: nodeData?.nameField?.metadata?.value,
    phone: nodeData?.phoneField?.metadata?.value,
    email: nodeData?.emailField?.metadata?.value,
    message: nodeData?.messageField?.metadata?.value
  };
  const [inputVal, setInputVal] = useState(formInitialValue);

  const [validData, setValidData] = useState({
    nameValid: 1,
    emailValid: 1,
    phoneValid: 1,
    messageValid: 1
  });

  useEffect(() => {
    if (
      validData?.nameValid &&
      validData?.emailValid &&
      validData?.phoneValid &&
      validData?.messageValid &&
      inputVal?.email &&
      inputVal?.name &&
      inputVal?.phone &&
      inputVal?.message
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [validData, inputVal]);

  const handleSubmit = () => {
    let data = {
      sectionId: sectionData?._id || null,
      sectionType: sectionData?.type,
      payload: inputVal,
      orgCode: extraProps?.org_code,
      orgId: extraProps?.org_id,
      ...(isLandingPages && {
        source: 'landing_page'
      })
    };
    if (!(isPreview || isEdit)) postApiCall(baseURLs, data);
    setBtnDisabled(true);
    setInputVal(formInitialValue);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
    }, 1000);
  };

  const checkValidity = (regexField, fieldname, fieldValidity) => {
    if (validations?.[regexField]?.length) {
      let regex = new RegExp(validations[regexField]);
      if (regex?.test(inputVal[fieldname])) {
        setValidData({ ...validData, [fieldValidity]: 1 });
      } else {
        setValidData({ ...validData, [fieldValidity]: 0 });
      }
    }
  };
  return (
    <section className={classes.section}>
      <div className={classes.formContainer}>
        <div className={classes.partialBackground} />
        <div className={classes.sectionContainer}>
          <div className={classes.contentContainer}>
            <div className={classes.leftContainerForm}>
              <h2 className={classes.title}>
                <span
                  ref={nodeData?.title?.refSetter}
                  dangerouslySetInnerHTML={{
                    __html: nodeData?.title?.metadata?.value
                  }}
                />
              </h2>
              <div
                ref={nodeData?.subtitle?.refSetter}
                className={classes.subtitle}
                dangerouslySetInnerHTML={{
                  __html: nodeData?.subtitle?.metadata?.value
                }}
              />
              <div className={classes.addressContainer}>
                <div className={classes.addressRow}>
                  <span className={classes.addressImg}>
                    <Icon
                      name={'Location'}
                      color={theme.palette.font.primary}
                      width={'12px'}
                    />
                  </span>
                  <div
                    ref={nodeData?.address?.refSetter}
                    className={classes.addressText}
                    dangerouslySetInnerHTML={{
                      __html: nodeData?.address?.metadata?.value
                    }}
                  />
                </div>
                <div className={classes.addressRow}>
                  <span className={classes.addressImg}>
                    <Icon
                      name={'Phone'}
                      color={theme.palette.font.primary}
                      width={'12px'}
                    />
                  </span>
                  <div
                    ref={nodeData?.phoneNumber?.refSetter}
                    className={classes.addressText}
                    dangerouslySetInnerHTML={{
                      __html: nodeData?.phoneNumber?.metadata?.value
                    }}
                  />
                </div>
                <div className={classes.addressRow}>
                  <span className={classes.addressImg}>
                    <Icon
                      name={'Email'}
                      color={theme.palette.font.primary}
                      width={'12px'}
                    />
                  </span>
                  <div
                    ref={nodeData?.email?.refSetter}
                    className={classes.addressText}
                    dangerouslySetInnerHTML={{
                      __html: nodeData?.email?.metadata?.value
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={classes.rightContainer}>
              <div className={classes.inputDiv}>
                <Input
                  data={nodeData.nameField}
                  value={inputVal.name}
                  isValid={validData.nameValid}
                  inputType={'input'}
                  onChange={(e) => {
                    setInputVal({ ...inputVal, name: e.target.value });
                  }}
                  onBlur={() => {
                    checkValidity(
                      nodeData?.nameField?.metadata?.validationType,
                      'name',
                      'nameValid'
                    );
                  }}
                  onFocus={() => {
                    setValidData({ ...validData, nameValid: 1 });
                  }}
                />
              </div>

              <div className={classes.inputDiv}>
                <Input
                  data={nodeData.phoneField}
                  value={inputVal.phone}
                  isValid={validData.phoneValid}
                  inputType={'input'}
                  onChange={(e) => {
                    setInputVal({ ...inputVal, phone: e.target.value });
                  }}
                  onBlur={() => {
                    checkValidity(
                      nodeData?.phoneField?.metadata?.validationType,
                      'phone',
                      'phoneValid'
                    );
                  }}
                  onFocus={() => {
                    setValidData({ ...validData, phoneValid: 1 });
                  }}
                />
              </div>

              <div className={classes.inputDiv}>
                {' '}
                <Input
                  data={nodeData.emailField}
                  value={inputVal.email}
                  isValid={validData.emailValid}
                  inputType={'input'}
                  onChange={(e) => {
                    setInputVal({ ...inputVal, email: e.target.value });
                  }}
                  onBlur={() => {
                    checkValidity(
                      nodeData?.emailField?.metadata?.validationType,
                      'email',
                      'emailValid'
                    );
                  }}
                  onFocus={() => {
                    setValidData({ ...validData, emailValid: 1 });
                  }}
                />
              </div>

              <div className={classes.inputDiv}>
                {' '}
                <Input
                  data={nodeData.messageField}
                  value={inputVal.message}
                  isValid={validData.messageValid}
                  inputType={'textarea'}
                  onChange={(e) => {
                    setInputVal({ ...inputVal, message: e.target.value });
                  }}
                  onBlur={() => {
                    checkValidity(
                      nodeData?.messageField?.metadata?.validationType,
                      'message',
                      'messageValid'
                    );
                  }}
                  onFocus={() => {
                    setValidData({ ...validData, messageValid: 1 });
                  }}
                />
              </div>

              {nodeData.cta.metadata.value !== '' && (
                <div className={classes.btnContainer}>
                  <Button
                    ref={nodeData?.cta?.refSetter}
                    data={
                      isSubmitted
                        ? { value: 'Submitted' }
                        : { value: nodeData.cta.metadata.value }
                    }
                    onClick={() => handleSubmit()}
                    type={nodeData?.cta?.metadata?.type}
                    size={isMobile ? 'small' : 'medium'}
                    disabled={btnDisabled}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
